import { Box } from '@material-ui/core';
import { useAuth } from '../../../hooks/useAuth';
import ComparativoReceitaRecebidoClube from './ComparativoReceitaRecebidoClube';
import ComparativoReceitaRecebidoFranquia from './ComparativoReceitaRecebidoFranquia';

const ComparativoReceitaRecebido = () => {

  const { ...auth } = useAuth()
  const isClubUser = (auth.isM3tasUser() || auth.isGlobalUser())

  return (
    <>
      <ComparativoReceitaRecebidoFranquia />
      {isClubUser && (
        <>
          <Box style={{ marginTop: 30 }} />
          <ComparativoReceitaRecebidoClube />
        </>
      )}
    </>
  )
}

export default ComparativoReceitaRecebido